import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import type { MemberSummary } from '@techsofit/api-types';
import { Avatar, StatusBadge, cn } from '@techsofit/ui';
import { statusToBadge } from '../lib/membership';
import { relativeDays } from '../lib/format';

interface MemberRowProps {
  member: MemberSummary;
  /** @deprecated Reminders are fully automatic now — no manual nudge. Kept so
   *  existing callers (dashboard lists) don't need to change. */
  showNudge?: boolean;
  className?: string;
}

export function MemberRow({ member, className }: MemberRowProps) {
  const navigate = useNavigate();
  const badge = statusToBadge(member.status);
  const openRecord = () => navigate(`/members/${member.id}`);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={openRecord}
      onKeyDown={(e) => e.key === 'Enter' && openRecord()}
      className={cn(
        'group flex items-center gap-3 rounded-control p-2.5 transition-colors hover:bg-surface',
        className,
      )}
    >
      <Avatar name={member.fullName} />
      <div className="min-w-0 flex-1">
        <p className="truncate font-medium text-ink">{member.fullName}</p>
        <p className="truncate text-sm text-muted">
          {member.currentPlanName ?? 'No plan'} · <span className="tabular">{relativeDays(member.daysToExpiry)}</span>
        </p>
      </div>
      <StatusBadge status={badge} className="hidden sm:inline-flex" />
      <ChevronRight
        className="size-5 shrink-0 text-muted opacity-0 transition-opacity group-hover:opacity-100"
        aria-hidden
      />
    </div>
  );
}
